import { useScope } from './useScope';

type ScopeGateProps = {
  need: string;
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * Renders children only if the current user has the required scope.
 * Renders `fallback` (defaults to null) otherwise.
 */
export function ScopeGate({ need, fallback = null, children }: ScopeGateProps) {
  const hasScope = useScope(need);
  return hasScope ? <>{children}</> : <>{fallback}</>;
}
